import { constants } from "../../../common/constants/constants";
import { months } from "../../../common/translations/en/common/months";
import { i18n } from "../../../common/translations"
import BllinkUtils from "../../../common/utils/utils";


export default class TablesLogic{

    static getInitialData(extraHeaders, options){
        /**
         * used in yearly months and yearly cashflow
         */
        options = options || {};
        let currentYear = BllinkUtils.BllinkTime.getCurrentYear();
        let yearsOptions = []
        for (let i=3; i>=-1; i--){
            yearsOptions.push(currentYear - i)
        }
        let monthHeaderFunc = options.isPaymentSettings ? 'renderMonth' : 'renderMonthLink';
        let monthRowFunc = options.isPaymentSettings ? 'renderMonthText' : 'renderIcon';
        let renderApartmentFunc = options.isPaymentSettings ? 'renderApartment' : 'renderApartmentLink';
        let monthsHeaders = constants.months.map(monthInt => {
            return {label: i18n.t(`common.months.${monthInt}`), functionName: monthHeaderFunc, data: monthInt}
        })
        // ugly hack due to ux breaking with long September
        months["9"] = 'September';
        let rowsFields = Object.values(months).map(monthNameInEnglish => { return {fieldName: monthNameInEnglish.toLowerCase(), functionName: monthRowFunc}})

        // one time payments columns, if any
        if (extraHeaders){
            const oneTimeHeaders = extraHeaders.map(headerData=> {return headerData.name});
            const rowsOneTimeFields = extraHeaders.map(headerData=> {return {fieldName: `one_time_${headerData.id}`, functionName: 'renderOneTimeIcon'}});
            monthsHeaders = monthsHeaders.concat(oneTimeHeaders);
            rowsFields = rowsFields.concat(rowsOneTimeFields);
        }

        const headerNames = [
            i18n.t('reports.apartmentName'),
            i18n.t('reports.tenantName')]
            .concat(monthsHeaders);
        const rowsFieldsData = [
            {fieldName: 'apartmentName', functionName: renderApartmentFunc},
            'tenantName']
            .concat(rowsFields);

        return {
            headerNames: headerNames,
            rowsFields: rowsFieldsData,
            yearsOptions: yearsOptions,
            currentYear: currentYear
        }

    }

}
